import { AceEditorTheme } from 'modules/aceEditor';
import { ModalContextProvider } from 'utils/contexts/modal';
import { isValidEnumValue } from 'utils/tsHelpers';
import { Editor, EditorProps } from './components/Editor';
import { CreativeLibraryContextProvider } from './contexts/CreativeLibraryContext';
import { MovableInkContextProvider } from './contexts/MovableInk';
import { DynamicContentBuilderContextProvider } from './contexts/DynamicContentBuilderContext';
import { HtmlLoaderProvider } from './contexts/HtmlLoaderContext';
import { EditorContextProvider } from './contexts/SideBySideEditorContext';
import { SnippetSelectorProvider } from './contexts/SnippetSelectorContext';

type SideBySideEditorProps = EditorProps & {
  canLoadHTML?: boolean;
};

export const SideBySideEditor = ({
  canLoadHTML = false,
  theme,
  ...aceEditorProps
}: SideBySideEditorProps) => (
  <ModalContextProvider>
    <EditorContextProvider
      aceEditorTheme={isValidEnumValue(theme, AceEditorTheme) ? theme : AceEditorTheme.Monokai}
    >
      <DynamicContentBuilderContextProvider>
        <HtmlLoaderProvider canLoadHTML={canLoadHTML}>
          <CreativeLibraryContextProvider>
            <MovableInkContextProvider>
              <SnippetSelectorProvider>
                <Editor {...aceEditorProps} />
              </SnippetSelectorProvider>
            </MovableInkContextProvider>
          </CreativeLibraryContextProvider>
        </HtmlLoaderProvider>
      </DynamicContentBuilderContextProvider>
    </EditorContextProvider>
  </ModalContextProvider>
);
